import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Archive from 'lucide-react/dist/esm/icons/archive.mjs'
import Layers3 from 'lucide-react/dist/esm/icons/layers-3.mjs'
import Package from 'lucide-react/dist/esm/icons/package.mjs'
import Search from 'lucide-react/dist/esm/icons/search.mjs'
import Smartphone from 'lucide-react/dist/esm/icons/smartphone.mjs'
import Link2 from 'lucide-react/dist/esm/icons/link-2.mjs'
import { useProjectData } from '../store/AppStore'
import { ModalShell } from '../shared/ui/ModalShell'
import { platformMeta } from '../shared/utils/formatters'

export function GlobalSearchDialog({ close, allowedPermissions }) {
  const { filter } = useProjectData()
  const navigate = useNavigate()
  const [query, setQuery] = useState('')

  const results = useMemo(() => {
    const keyword = query.trim().toLowerCase()
    if (!keyword) return []
    const includes = value => value.toLowerCase().includes(keyword)
    return [
      ...(allowedPermissions.has('matrix') ? filter('accounts').filter(item => includes(`${item.name}${platformMeta[item.platform].label}`)).map(item => ({ id: item.id, label: item.name, meta: platformMeta[item.platform].label, route: '/matrix', icon: Smartphone })) : []),
      ...(allowedPermissions.has('templates') ? filter('templates').filter(item => includes(`${item.name}${item.code}`)).map(item => ({ id: item.id, label: item.name, meta: item.code, route: '/templates', icon: Layers3 })) : []),
      ...(allowedPermissions.has('inventory') ? filter('assets').filter(item => includes(`${item.title}${item.code}`)).slice(0, 8).map(item => ({ id: item.id, label: item.title, meta: item.code, route: '/inventory', icon: Archive })) : []),
      ...(allowedPermissions.has('products') ? filter('products').filter(item => includes(`${item.name}${item.category}`)).map(item => ({ id: item.id, label: item.name, meta: item.category, route: '/products', icon: Package })) : []),
      ...(allowedPermissions.has('references') ? filter('references').filter(item => includes(`${item.title}${item.author}`)).map(item => ({ id: item.id, label: item.title, meta: `@${item.author}`, route: '/references', icon: Link2 })) : []),
    ].slice(0, 12)
  }, [allowedPermissions, filter, query])

  const openResult = result => {
    navigate(result.route, { state: { focusId: result.id } })
    close()
  }

  return <ModalShell eyebrow="GLOBAL SEARCH" title="搜索项目内容" close={close} className="global-search-modal">
    <div className="modal-content">
      <div className="command-search"><Search size={18}/><input autoFocus value={query} onChange={event => setQuery(event.target.value)} placeholder="搜索账号、模板、作品、产品或参考作品"/><kbd>ESC</kbd></div>
      <div className="command-results">
        {!query ? <div className="command-empty"><Search size={24}/><b>输入关键词开始搜索</b><span>结果仅展示当前项目内的数据</span></div> : null}
        {query && results.length === 0 ? <div className="command-empty"><b>没有找到匹配内容</b><span>尝试搜索更短的名称或编号</span></div> : null}
        {results.map(result => { const Icon = result.icon; return <button key={`${result.route}-${result.id}`} onClick={() => openResult(result)}><span><Icon size={16}/></span><div><b>{result.label}</b><small>{result.meta}</small></div></button> })}
      </div>
    </div>
  </ModalShell>
}
